import { Button } from 'primereact/button';
import { midiHandler } from "../MidiHandler";
import { useOnPress } from "../hooks/useOnPress";
import { useEffect, useState } from 'react';

export const MidiPad = ({ style, className, instrument, pitch, isSelected, setSelected, label, ...props }) => {

    const pressProps = useOnPress({
        onPress: () => {
            setSelected();
            midiHandler.sendNoteOn(instrument.id, pitch, 127);
        },
        onUnpress: () => {
            midiHandler.sendNoteOff(instrument.id, pitch, 0);
        }
    });

    const [isPlaying, setIsPlaying] = useState(false);
    function updateIsPlaying(midiEvent) {
        if (midiEvent.detail.pitch !== pitch) return;
        setIsPlaying(midiEvent.detail.type !== 'noteOff');
    }
    useEffect(() => {
        document.addEventListener("midiNote-" + instrument.id , updateIsPlaying);
        return () => document.removeEventListener("midiNote-" + instrument.id , updateIsPlaying);
    }, [pitch])
 
    return (
        <Button
            {...props}
            className={`btn ${isSelected || isPlaying ? 'selected': ''} ${className}` }
            style={style}
            {...pressProps}
            label={label}
        />
    )
}